import styled from 'styled-components'

export const StyledSecondSubNavItemContainer = styled.div`
  font-size: 12px;
  margin-left: 10px;
  font-style: italic;
`
